module.exports = __webpack_public_path__ + "img/m_reward.bb7964cd.png";